import React from 'react';
import sehsuchte1 from '../../assets/img/projects/sehsuchte1.jpg'
import sehsuchte2 from '../../assets/img/projects/sehsuchte2.jpg'
import sehsuchte3 from '../../assets/img/projects/sehsuchte3.jpg'
import sehsuchte4 from '../../assets/img/projects/sehsuchte4.jpg'

const Fantasynth = () =>
{
    console.log('rendered');
    return(
        <div>
           <Text/>
            <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ sehsuchte1 }
                alt="sehsuchte1"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ sehsuchte3 }
                alt="sehsuchte3"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ sehsuchte2 }
                alt="sehsuchte2"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ sehsuchte4 }
                alt="sehsuchte4"
            />
            <br></br>
            <br></br>
        </div>
    );
}

export default Fantasynth;

const Text = () =>
{
    return(
        <div className="Project-Content">
            FANTASYNTH is a real-time installation that offers a gimps into the worlds where different perceptual traditions are defied, and the borders between 'fictional real' and 'fictional virtual' are compromised. 
            <br></br>
            <br></br>
            The installation incorporates two means of storytelling – procedural generation and using a conventional form of displaying video footage on the screen. Procedural footage is a 2 min never-ending  loop run in real-time. It tells a short abstract story of an insect named Vincent and ends differently each time. 
            <br></br>
            <br></br>
            Trying to deconstruct the notion of digital realities, I dwell on the philosophical ideas of rebirth and repetition on one hand, and contemplate about escapism and fantasy as alternatives to reality, on the other. By building digital worlds that do not exist, the author constructs islands of retreat in new mental structures of the digital.
            <br></br>
            <br></br>
            The work opens a way to dialogue between media, art, philosophy, and technology and reflects on challenges to knowledge brought by the novel forms of perceptual experience and 3D aesthetics. An attentive viewer may also ask the questions about the ontology of digital reality, its short- and long-term consequences, and its uncanny potential for a future perceptual change.
        </div>
    );
}